import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { key: 0 }


import { IonItem, IonLabel } from '@ionic/vue';
import BasicNormalInput from './form-elements/BasicNormalInput.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'BasicSearchByCodeBlock',
  props: {
    foundType: null,
    modelValue: null
  },
  emits: ['update:modelValue'],
  setup(__props: any, { emit }) {

const props = __props as {
    foundType: string;
    modelValue: string;
};





return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(IonItem), {
    class: "ion-no-padding ion-margin-bottom",
    style: {"margin":"0 15px"}
  }, {
    default: _withCtx(() => [
      _createVNode(_unref(IonLabel), { position: "stacked" }, {
        default: _withCtx(() => [
          _createTextVNode(" Code: "),
          (props.foundType)
            ? (_openBlock(), _createElementBlock("span", _hoisted_1, "(matched by: " + _toDisplayString(props.foundType) + ")", 1))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }),
      _createVNode(BasicNormalInput, {
        name: "code",
        value: props.modelValue,
        onInput: _cache[0] || (_cache[0] = ($event: any) => (emit('update:modelValue', $event.target.value)))
      }, null, 8, ["value"])
    ]),
    _: 1
  }))
}
}

})